import React from 'react';
import { makeStyles } from '@material-ui/core';

import { useMediaQuery } from 'ha/helpers/MediaQuery';
import NavBarBottom from 'ha/modules/NavBarBottom';

const useStyles = makeStyles(theme => ({
  fixedFooter: {
    width: '100%',
    zIndex: 1020,
    bottom: 0,
    position: 'sticky',
    background: theme.palette.common.white,
  },
}));

interface OwnProps {
  fixedFooterContent?: React.ReactNode;
  isAuthenticated: boolean;
  showBottomNav?: boolean;
}

const FixedFooterSection: React.FC<OwnProps> = ({
  fixedFooterContent,
  isAuthenticated,
  showBottomNav,
}) => {
  const { fixedFooter } = useStyles();
  const { md } = useMediaQuery();

  const isBottomNavVisible = !md && isAuthenticated && showBottomNav;

  return (
    <div className={fixedFooter}>
      {fixedFooterContent}
      {isBottomNavVisible && <NavBarBottom />}
    </div>
  );
};

export default FixedFooterSection;
